import React, { useContext } from "react";
import { depascalize, Grid, GridColumn, GridRow, LabeledText } from "sprint-common-web";

import { MuxerType } from "../../../../common/types/MuxerType";
import { MuxSpecificationDashboardContext } from "../context/MuxSpecificationDashboardContext";
import { ensureIsGpacMuxSpecification } from "../MuxSpecificationDashboardItem";

export const GpacMuxSpecificationInfoContent: React.FunctionComponent = () => {
    const { muxSpecificationDashboardItem } = useContext(MuxSpecificationDashboardContext);
    ensureIsGpacMuxSpecification(muxSpecificationDashboardItem);

    return (
        <Grid>
            <GridRow>
                <GridColumn lg={12}>
                    <LabeledText label="Name" value={muxSpecificationDashboardItem.name} />
                    <LabeledText label="Muxer Type" value={depascalize(MuxerType[MuxerType.GPAC])} />
                </GridColumn>
            </GridRow>
        </Grid>
    );
};
